import { PayrollBreakdown, TimeSheetState } from "../../../__generated__/graphql";
import React, { useMemo } from "react";
import { useI18n } from "../../../hooks/i18n-hooks";

import VStack from "../../../ui_atoms/VStack";
import Table from "../../../ui_atoms/Table";
import { minutesAsString } from "../../../utils";

type PayrollBreakdownHourlyInfoProps = {
    payrollBreakdown: PayrollBreakdown;
    disabled?: boolean;
};

const PayrollBreakdownHourlyInfo: React.FC<PayrollBreakdownHourlyInfoProps> = ({
    payrollBreakdown,
    disabled = false,
}) => {
    const allCompleted = payrollBreakdown?.timesheets?.every(
        (ts) => ts.status === TimeSheetState.Submitted || ts.status === TimeSheetState.Accepted,
    );
    const i18n = useI18n();
    const tableData = useMemo(
        () =>
            [
                {
                    title: i18n.t("payroll_breakdown.field_totalWork100"),
                    value: disabled
                        ? "--"
                        : minutesAsString(payrollBreakdown.totalWork100 || 0, {
                              separator: "h",
                              zeroPlaceholder: !allCompleted ? "--" : undefined,
                          }),
                },
                {
                    title: i18n.t("payroll_breakdown.field_totalWork125"),
                    value: disabled
                        ? "--"
                        : minutesAsString(payrollBreakdown.totalWork125 || 0, {
                              separator: "h",
                              zeroPlaceholder: !allCompleted ? "--" : undefined,
                          }),
                },
                {
                    title: i18n.t("payroll_breakdown.field_totalWork150"),
                    value: disabled
                        ? "--"
                        : minutesAsString(payrollBreakdown.totalWork150 || 0, {
                              separator: "h",
                              zeroPlaceholder: !allCompleted ? "--" : undefined,
                          }),
                },
            ].filter((x) => x.value !== null),
        [
            i18n,
            disabled,
            payrollBreakdown.totalWork100,
            payrollBreakdown.totalWork125,
            payrollBreakdown.totalWork150,
            allCompleted,
        ],
    );
    return (
        <VStack style={{ opacity: disabled ? 0.3 : 1.0 }}>
            <Table
                data={tableData.map((item) => ({
                    cells: [
                        {
                            value: item.title,
                        },
                        {
                            bold: true,
                            value: item.value,
                        },
                    ],
                }))}
            />
        </VStack>
    );
};

export default PayrollBreakdownHourlyInfo;
